import {combineReducers} from "redux";
import company from "features/modals/company/reducer";

export default combineReducers({
    company
});